import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'bmcore-favourite-icon',
  templateUrl: './bmcore-favourite-icon.component.html',
  styleUrls: ['./bmcore-favourite-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreFavouriteIconComponent {
  @Input() fillColor = 'currentColor'
  @Input() width = 24
  @Input() height = 24
}
